// extracted by mini-css-extract-plugin
export default {"container":"style_container__sIxS6","label":"style_label__oVsT6"};